import React from 'react';
import FullPageLoading from '../FullPageLoading/FullPageLoading';
import { useOnboarding } from '../../contexts/OnboardingContext';

interface RequireOnboardingProps {
    children: React.ReactNode;
}

/**
 * AB#1675 — Onboarding-gate behaviour change.
 *
 * Previously: if `status === 'none' | 'incomplete'`, redirect to `/onboarding`
 *   (the legacy 5-step forced wizard).
 * Now: pass through. The salon owner lands on the dashboard regardless of
 *   onboarding state. The two new entry points (sidebar "My Business" item
 *   with red dot, profile-menu link with SET UP tag) surface the setup
 *   tasks without forcing them.
 *
 * The component is kept (not deleted) so the existing route wiring still
 * works and we can re-enable the gate behind a feature flag if launch needs
 * it. The loading spinner stays so the dashboard waits for the onboarding
 * status before rendering (avoids layout flash when status arrives late).
 */
const RequireOnboarding: React.FC<RequireOnboardingProps> = ({ children }) => {
    const { status } = useOnboarding();

    if (status === 'loading') {
        return (
            <FullPageLoading />
        );
    }

    return <>{children}</>;
};

export default RequireOnboarding;
